import dayjs from "dayjs";
import "dayjs/locale/ja";
import type { FC } from "react";
import { ButtonUI } from "../../../../components/Button";
import { emailToNameMap } from "../../../../constants/email-senders";
import type { DeliveryHistory } from "../../../../hooks/useDeliveryHistoriesRestApi";
import type { DeliveryOpenRateAnalyticsResponse } from "../../../../utils/open-rate-utils";

dayjs.locale("ja");

export type DeliveryHistoriesItemUIProps = {
  deliveryHistory: DeliveryHistory;
  openRate?: DeliveryOpenRateAnalyticsResponse[string];
  openRatesLoaded: boolean;
  onResend: (history: DeliveryHistory) => void;
  onSelectHistory: (id: string) => void;
};

export const DeliveryHistoriesItemUI: FC<DeliveryHistoriesItemUIProps> = ({
  deliveryHistory,
  openRate,
  openRatesLoaded,
  onResend,
  onSelectHistory,
}) => {
  const {
    subject,
    bulkEmailsTotal,
    bulkEmailsSuccessTotal,
    from,
    deliveryType,
    createdAt,
  } = deliveryHistory;

  return (
    <tr
      className="cursor-pointer hover:bg-blue-100 overflow-visible"
      onClick={() => onSelectHistory(deliveryHistory.id)}
    >
      <td className="px-3 py-2" style={{ width: "23.18%", maxWidth: "278px" }}>
        <div
          className={`w-full text-left${
            subject
              ? " tooltip tooltip-top before:max-w-xs before:content-[attr(data-tip)] before:text-left before:whitespace-pre-wrap"
              : ""
          }`}
          {...(subject ? { "data-tip": subject } : {})}
        >
          <span className="block truncate">{subject}</span>
        </div>
      </td>
      <td
        className="px-3 py-2 text-ellipsis whitespace-nowrap overflow-hidden"
        style={{ width: "14.38%", maxWidth: "173px" }}
      >
        {bulkEmailsTotal === bulkEmailsSuccessTotal ? "成功" : "失敗"}（
        {bulkEmailsSuccessTotal}／{bulkEmailsTotal}）
      </td>
      <td
        className="px-3 py-2 text-ellipsis whitespace-nowrap overflow-hidden"
        style={{ width: "14.38%", maxWidth: "173px" }}
      >
        {!openRatesLoaded
          ? "取得中..."
          : openRate
            ? `${openRate.openRate.toFixed(0)}%（${
                openRate.uniqueOpens
              }／${bulkEmailsTotal}）`
            : "-"}
      </td>
      <td
        className="px-3 py-2 text-ellipsis whitespace-nowrap overflow-hidden"
        style={{ width: "9.61%", maxWidth: "115px" }}
      >
        {deliveryType}
      </td>
      <td
        className="px-3 py-2 text-ellipsis whitespace-nowrap overflow-hidden"
        style={{ width: "9.61%", maxWidth: "115px" }}
      >
        {emailToNameMap[from] || from}
      </td>
      <td
        className="px-3 py-2 text-ellipsis whitespace-nowrap overflow-hidden"
        style={{ width: "17.94%", maxWidth: "215px" }}
      >
        {dayjs(createdAt).format("YYYY/MM/DD (ddd) HH:mm")}
      </td>
      <td className="px-3 py-2" style={{ width: "10.91%", maxWidth: "131px" }}>
        <ButtonUI
          size="sm"
          type="button"
          color="success"
          onClick={e => {
            e.stopPropagation();
            onResend(deliveryHistory);
          }}
        >
          再配信
        </ButtonUI>
      </td>
    </tr>
  );
};
